import { useEffect, useState } from "react";
import "./banner.css";

export default function Banner() {

const banners = [

  {
    image:
      "https://images.unsplash.com/photo-1603909223429-69bb7101f420?q=80&w=1974&auto=format&fit=crop",

    title:
      "THCA Flower Collection",

    subtitle:
      "Premium Indoor Exotic Flower"
  },

  {
    image:
      "https://images.unsplash.com/photo-1599599810769-bcde5a160d32?q=80&w=1974&auto=format&fit=crop",

    title:
      "CBD Gummies & Oils",

    subtitle:
      "Relax • Sleep • Wellness"
  },

  {
    image:
      "https://images.unsplash.com/photo-1600959907703-125ba1374a12?q=80&w=1974&auto=format&fit=crop",

    title:
      "Smoke Essentials",

    subtitle:
      "Vapes • Grinders • Accessories"
  },

  {
    image:
      "https://images.unsplash.com/photo-1578500494198-246f612d3b3d?q=80&w=1974&auto=format&fit=crop",

    title:
      "Premium Vape Collection",

    subtitle:
      "Modern Smoke Experience"
  }

];
  const [current, setCurrent] = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {

      setCurrent((prev) =>
        prev === banners.length - 1
          ? 0
          : prev + 1
      );

    }, 4000);

    return () => clearInterval(interval);

  }, []);

  return (

    <div
      className="banner"
      style={{
        backgroundImage:
          `url(${banners[current].image})`
      }}
    >

      <div className="banner-overlay">

        <h1>
          {banners[current].title}
        </h1>

        <p>
          {banners[current].subtitle}
        </p>

        <button
  onClick={() =>
    window.scrollTo({
      top: 600,
      behavior: "smooth"
    })
  }
>
  Shop Now
</button>

      </div>

    </div>
  );
}